import {compose} from 'redux';
import {withRouter} from 'react-router-dom';
import withNextStep from "../../components/hoc/withNextStep";
import Step12 from './Step12-redux';

export default compose(
  withRouter,
  withNextStep
)(Step12);
